import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer: React.FC = () => {
  const location = useLocation();
  const currentYear = new Date().getFullYear();

  // Hide footer on home page (it has its own minimal footer)
  if (location.pathname === '/') {
    return null;
  }

  return (
    <footer className="glass-footer">
      <div className="glass-container py-4">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-xs" style={{ color: 'rgba(255, 255, 255, 0.5)' }}>
            &copy; {currentYear} Crisci Create. All rights reserved.
          </p>
          <div className="flex space-x-4">
            <Link
              to="/privacy"
              className="text-xs transition-colors"
              style={{ color: 'rgba(255, 255, 255, 0.4)' }}
              onMouseEnter={(e) => e.currentTarget.style.color = 'white'}
              onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.4)'}
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="text-xs transition-colors"
              style={{ color: 'rgba(255, 255, 255, 0.4)' }}
              onMouseEnter={(e) => e.currentTarget.style.color = 'white'}
              onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.4)'}
            >
              Terms
            </Link>
            <Link
              to="/contact"
              className="text-xs transition-colors"
              style={{ color: 'rgba(255, 255, 255, 0.4)' }}
              onMouseEnter={(e) => e.currentTarget.style.color = 'white'}
              onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.4)'}
            >
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
